module.exports = __webpack_public_path__ + "media/אופנים.8ecf33ad.mp3";